import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // ✅ named import
import UnauthorizedPage from "../Components/AdminPanelComponents/LoginComponents/UnauthorizedPage";

/**
 * Protects routes based on allowed roles.
 * @param {Array} allowedRoles - list of roles allowed to access route
 */
const ProtectedRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("authToken");

  // No token → redirect to login
  if (!token) return <Navigate to="/" replace />;

  try {
    const decoded = jwtDecode(token);

    // Check if token has expired
    if (decoded.exp * 1000 < Date.now()) {
      localStorage.clear();
      return <Navigate to="/" replace />;
    }

    const userRole = decoded.systemRole; // systemRole from token

    // Role not allowed → show Unauthorized page
    if (!allowedRoles.includes(userRole)) {
      return <UnauthorizedPage />;
    }

    // All good → render child routes
    return <Outlet />;
  } catch (error) {
    console.error("Invalid token in ProtectedRoute:", error);
    localStorage.clear();
    return <Navigate to="/" replace />;
  }
};

export default ProtectedRoute;
